<template>
    <draggable
        :list="obtenerListaDeElementos"
        :disabled="!habilitado"
        :scroll-sensitivity="50"
        :force-fallback="false"
        id="listaOrdenable_arrastrable"
        class="listaOrdenable"
        handle=".Lista-titulo-texto"
        dragClass="listaOrdenable-arrastra"
        chosenClass="listaOrdenable-selecciona" 
        ghost-class="listaOrdenable-fantasma"
        @start="arrastrando = true"
        @end="finalizoArrastre">
            <div v-bind:class="[arrastrando?'listaOrdenable-arrastra':'listaOrdenable-hover','contenidoLista']" v-for="(elemento, index) in obtenerListaDeElementos" :key="index" @mouseover="elemento.hover = true" @mouseleave="elemento.hover = false">
                <div v-bind:class="[elemento.hover ? 'contenidoLista-hover contenidoLista-scroll' : 'contenidoLista-no-hover contenidoLista-scroll']">
                    <div class="Lista-titulo-texto">
                        <h6>
                            <b>#Folio: {{ elemento[referenciasElemento.folio] }}</b>
                        </h6>
                        <h6 v-if="informacionAmostrar.fechaPublicacion" v-html="elemento[referenciasElemento.fechaPublicacion]"></h6>
                        <h6 v-if="informacionAmostrar.descripcion" v-html="elemento[referenciasElemento.descripcion]"></h6>
                    </div>
                    <!-- AGREGAR MAS ELEMENTOS DESCRIPTIVOS SI EL ELMENTO LO NECESITA A PARTIR DE ESTA LINEA -->
                </div>
            </div>
    </draggable>   
</template>

<script>
    import draggable from "vuedraggable";
    import { tooltipF } from '@/../static/js/tooltip/ToolTipDirective.js'

 
    export default {
        directives: {
            tooltipF
        },
        components: {
            draggable
        },
        props: {
            elementos: {
                type: Array,
                default: () => []
            },
            referenciasElemento: {
                type: Object,
                default: () => ({ folio: 'id', orden: 'or',fechaPublicacion: 'fp', descripcion: 'des' }) // si se requiere agregar mas referencias
            },
            informacionAmostrar: {
                type: Object,
                default: () => ({ folio: true, fechaPublicacion: false, descripcion: false }) // si se requiere agregar mas campos para el item
            },
            configuarcionesDragg: {
                type: Object,
                default: () => ({ hover: true }) // si se requiere agregar mas campos para el item
            },
        },
        data() {
            return {
                habilitado: true,
                editado: false,
                arrastrando: false,
                listadoElementosOrdenados:[]
            };
        },
        methods: {
            obtenerFechaConFormato: function(fecha){
                moment.locale("es");
                return moment(fecha).format('DD MMMM YYYY');
            },
            /**
             * Metodo encargado de restablecer el orden de los contenidos en base la interaccion del usuario
             * con los items del draggable.  
             * @param {Object} e [evento emitido por el draggable]
             */
            finalizoArrastre: function(e) {
                this.arrastrando = false;
                
                let listado = this.obtenerListaDeElementos;
                this.editado = false
                for(var i=0; i<listado.length; i++){
                    let elemento = listado[i];
                    if(elemento[this.referenciasElemento.orden] != i + 1)
                        this.editado = true;
                }
                this.$emit("ModificacionEnListaDeElementos",this.editado, listado);
            },
            campoEsValido: function(campo) { 
                let esValido = false
                if(typeof campo === 'string' || campo instanceof String) {
                    // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
                    if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                        esValido = true;
                    }
                }
                else if (typeof campo === 'number' || campo instanceof Number) {
                    // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
                    if (campo != null && campo != undefined && campo > 0) {
                        esValido = true;
                    }
                }
                else {
                    if (campo != null && campo != undefined) {
                        esValido = true;
                    }
                }
                return esValido;
            }
        },
        computed: {
            obtenerListaDeElementos() {
                return this.elementos;
            }
        }
    }
</script>

<style scoped>
    .contenidoLista
    {
        position: relative;
        background: none;
        border: none;
        padding: 1%;
        width: 100%;
    }
    .contenidoLista-no-hover
    {
        background-color: #323335;
        border: 1px solid #FFFFFF;
        color: #FFFFFF;
        padding: 0.5em;
        /* white-space: pre-line; */
    }
    .contenidoLista-hover
    {
        background-color: #FFFFFF;
        border: 1px solid #000000;
        color: black;
        padding: 0.5em;
        /* white-space: pre-line; */
    }
    .Lista-titulo-texto
    {
        display: inline-block;
        cursor: move;
        min-width: 70%;
        max-width: 90%;
        user-select: none;
       /*  white-space: pre-line; */
    }

    .contenidoLista-scroll {
        overflow-y: auto;
        max-height: 80px;
        
    }
  
    .contenidoLista-titulo-icono
    {
        right: 0px;
        float: right;
        height: 100%;
        padding-left: 5px;
        cursor: pointer;
        margin-right: 1em;
    }
    .contenidoLista-iconos-extras
    {
        right: 0px;
        float: right;
        height: 100%;
        padding: 3px;
        margin-left: 0.4em;
        margin-right: 1em;
    }

    .contenidoLista-iconos-extras i
    {
        padding: 0.3em;
    }

    .listaOrdenable_div
    {
        background-color: #57585B;
        padding: 0.5%;
    }
    #listaOrdenable_arrastrable
    {
        background: #57585B ;
        max-height: 100%;
        padding: 5px;
    }
    .listaOrdenable-selecciona{
        opacity: 0.4;
    }
    .listaOrdenable-fantasma{
        opacity: 1;
        background:cadetblue;/*#323335;*/
    }
    .listaOrdenable-arrastra {
        opacity: 0.4;
    }
    h6{
       /*  white-space: pre-line; */
    }
    .tabla-listado-archivos{
        border-collapse: collapse;
        width: 100%;
        background-color: #26272b;
    }

    .tabla-listado-archivos th {
        top: 0;
        background: #474749;
        border: 1;
    }
</style>


// WEBPACK FOOTER //
// src/components/SICPO/Comun/ClistaOrdenable.vue